import React, { memo } from 'react'
import PropTypes from 'prop-types'
import EditableHTML from '@v4/components/common/EditableHTML'
import EditableContainer from '@v4/components/common/EditableContainer'
import { EDITOR_VARIANT } from '@v4/hooks/useEditor'
import { useQuestionTitle } from './QuestionTitle.hooks'

const QuestionTitle = props => {
	const [
		{ className, shadow, value, align, editable, placeholder, key },
		{ handleChange, handleFocus },
	] = useQuestionTitle(props)

	return (
		<EditableContainer key={key} visible={!!value} withoutBanner editable shadow={shadow}>
			<EditableHTML
				className={className}
				html={value}
				component="h1"
				variant="h3"
				displayEmpty
				editable={editable}
				align={align}
				shadow={shadow}
				placeholder={placeholder}
				editorVariant={EDITOR_VARIANT.SHORT}
				onChange={handleChange}
				onFocus={handleFocus}
				autoFocus={!value}
			/>
		</EditableContainer>
	)
}

QuestionTitle.propTypes = {
	className: PropTypes.string,
	questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	align: PropTypes.oneOf(['center', 'inherit', 'left', 'justify', 'right']),
	shadow: PropTypes.bool,
	textSize: PropTypes.string,
	placeholder: PropTypes.string,
}

QuestionTitle.defaultProps = {
	placeholder: 'Write your question here',
}

export default memo(QuestionTitle)
